import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { MYREVENUECHART_INIT_LOADING, MYREVENUECHART_INIT_SUCCESS, MYREVENUECHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  myRevenueChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {

}

const actions = {
  async initMyRevenueChart({ commit, state }, data) {
    commit(MYREVENUECHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.myRevenueChart
    if (apiUrl) {
      try {
        let params = {
          scope: data.scope,
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(MYREVENUECHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYREVENUECHART_INIT_FAIL)
      }
    } else {
      commit(MYREVENUECHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYREVENUECHART_INIT_LOADING](state) {
    state.myRevenueChart.init = 0
  },
  [MYREVENUECHART_INIT_SUCCESS](state, data) {
    const { myRevenueChart } = state
    myRevenueChart.menu = data.menu
    myRevenueChart.init = 1
    myRevenueChart.lastUpdated = new Date()
    myRevenueChart.scope = data.scope
    myRevenueChart.appId = data.appId
    myRevenueChart.info = data.info
    myRevenueChart.appIds = data.appIds
    Vue.set(myRevenueChart, 'chartInfo', data.chartInfo)
  },
  [MYREVENUECHART_INIT_FAIL](state) {
    state.myRevenueChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
